<template lang="pug">
  .height-100
    transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
      .box.lista-solicitud-vacaciones.contenedor-interno.position-relative(key="box-lista")
        .title
          span Cumpleaños
          span.icon.close(
            @click="$emit('close')"
          )
            i.fa.fa-close

        .body
          transition-group.contenedor-box-transition(name="fade-smooth-two", tag="div")
            .filtros.aic(key="input-filtros")
              .flex-1
                .filtro
                  .title-singular
                    p Mes
                  .select.display-flex
                    select.flex-1(v-model='mes' @change="fetch")
                      option(:value="o.codigo", v-for="o in meses") {{o.descripcion}}

              .boton-container(key="boton-filtro")
                button.button(@click="fetch")
                  span.icon.is-small
                    i.fa.fa-refresh.fa-fw.fa-lg
                  span Refrescar
          .information
            //- .is-desktop
            table.table.is-striped.is-bordered(
              v-show="lista.length !== 0"
            )
              thead
                th Empleado
                th Cumpleaños
                th.hide-break-1 Anexo
              transition-group.table-transition(
                name="fade-smooth",
                tag="tbody" v-show='lista.length !== 0',
                v-infinite-scroll='fetchByScroll',
                infinite-scroll-disabled='disabledScrollExecute',
                infinite-scroll-distance='2'
                )
                tr.row-table(
                  v-for="(o, index) in lista"
                  :key="`index_${index + 1}`"
                  :class="{ 'birthday-style': o.esCumpleanios }"
                )
                  td
                    .flex.aic
                      .flex.fdc.aic(v-if="o.pathFoto")
                        .avatar.mr-10
                          img(:src="o.pathFoto")
                      .margin-right-5(v-if="o.esCumpleanios")
                        i.fa.fa-birthday-cake.fs-17
                      span {{ o.nombre }}
                  td
                    span {{ o.fechaNacimiento | customDate}}
                    br
                    span.show-break-1(v-if="o.anexo") Anexo: {{ o.anexo }}
                  td.hide-break-1 {{ o.anexo }}
          .is-loading(v-show="isLoading")
            .icon
              i.fa.fa-spinner.fa-spin
</template>

<script>
import { mixin as clickaway }       from 'vue-clickaway';
import { apiGet, notify }  from '../util/general'
import moment from 'moment';
export default {
  name: 'view-cumpleanios',
  mixins: [ clickaway ],
  data () {
    return {
      lista                                 : [],
      mes                                   : moment().month() + 1,
      isLoading                             : false,
      disabledScrollExecute                 : false,
      noMore                                : false,
      isScroll                              : false,
      skip                                  : 0,
      name                                  : 'plantilla_empleados',
      mensajeProcesoPlantilla               : '',
      meses                                : [
        { codigo: 1, descripcion: 'Enero' },
        { codigo: 2, descripcion: 'Febrero' },
        { codigo: 3, descripcion: 'Marzo' },
        { codigo: 4, descripcion: 'Abril' },
        { codigo: 5, descripcion: 'Mayo' },
        { codigo: 6, descripcion: 'Junio' },
        { codigo: 7, descripcion: 'Julio' },
        { codigo: 8, descripcion: 'Agosto' },
        { codigo: 9, descripcion: 'Septiembre' },
        { codigo: 10, descripcion: 'Octubre' },
        { codigo: 11, descripcion: 'Noviembre' },
        { codigo: 12, descripcion: 'Diciembre' }
      ]
    }
  },
  computed : {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    }
  },
  methods: {
    fetch () {
      var vm                    = this
      vm.isLoading              = true
      vm.disabledScrollExecute  = true
      vm.noMore                 = false
      if (!vm.isScroll) {
        vm.lista = []
        vm.skip = 0
      }

      var obj = {
        mes: vm.mes,
        skip : vm.skip
      }

      apiGet(vm, '/empleado/cumpleanios', obj, function (data) {
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip += data.lista.length
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isScroll  = false
        vm.isLoading = false
      })
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .birthday-style
    background-color: #565CDE !important
    color: white
    &:hover
      background-color: #565CDE !important
  .seen
    background-color: #DA8D7D;
    padding: 0px 4px;
    margin-top: 3px;
    border-radius: 4px;
    color: #fff;
  .contenedor-interno
    .close
      position absolute
      top 3px
      right 3px
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px
  th
    text-align center

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  .is-close
    background-color: #ffd6d6 !important;

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    min-width: 300px
    width: 100%;
    z-index: 70;
    top 0

  .position-relative
    position relative

  .codigo-empleado
    position relative
    .control
      .input-container
        display flex
        align-items center
        .input
          flex 1
          width 100px
        .erase-data
          cursor pointer
          margin-left 5px

  .filtros-container
    padding-bottom 10px
    border-bottom 1px solid #ccc
  .title-filtro
    display flex
    text-align left
    padding-left 10px
    padding-bottom 10px
    margin-bottom 10px
    border-bottom 1px solid #ccc
    .text
      text-transform uppercase
      flex 1
    .caret
      cursor pointer

  .filtros
    margin-bottom 10px
    text-align left
    display flex


    .filtro
      display inline-block
      border 1px solid #cccccc
      background-color #f9f9f9
      padding 5px
      margin 5px
      border-radius 3px
      flex 1
      max-width 20rem
      .title-singular
        text-align left
        font-weight bold
        user-select: none
      .abierto-cerrado-container
        display flex
        .option
          padding 4px
          border 1px solid #565cde
          color #565cde
          cursor pointer
          transition all 0.3s ease
          height 31.5px

          &.selected
            background-color: #565cde;
            color: #fff;

      .list-container
        padding 0px 10px 0px 10px
        .option
          user-select: none
          cursor pointer
          &.selected
            color #565cde
            font-weight bold

  .boton-container
    button
      margin-left 5px
      margin-top 5px



  .is-loading
    margin-top 10px

  .button.is-loading
    margin-top 0px

  .information
    padding-top 10px

  th
    vertical-align: middle;
  td
    vertical-align: middle;

  td
    .email
      font-size 12px
      color #9a9a9a

  .table
    font-size 13px

  .td-status
    width: 50px;

  .status
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .circle
      width: 25px;
      height: 25px;
      border-radius: 50%
      transition background ease-in .15s
      border 1px solid #d8d8d8
      background-color #23d160
      &.green
        background-color #23d160
      &.yellow
        background-color #ffdd57
      &.red
        background-color #ff0000
      &.white
        background-color #ffffff

  .status-container-filtro
    display flex
    justify-content center
    align-items center
    .status
      margin 5px
      cursor pointer
      .circle
        transition all ease-in .15s
        width: 30px;
        height: 30px;
      &.selected
        .circle
          border 2px solid #565cde
  .card-footer-item:not(:last-child)
    border-right: 1px solid #dbdbdb
  .info-box-button
    border-radius 0
    border        0px

  .card-content-observaciones-max-height
    max-height: calc(100vh - 300px);
    overflow: auto;
  .is-mobile
    display none
  .text-small
    font-size 12px
    color #9a9a9a

  .modal-sidebar-desktop-open
    width: calc(100% - 180px);


  .show-break-1
    display none
  @media screen and (max-width: 950px)
    .is-desktop
      display none
    .is-mobile
      display block

    .name
      font-size: 16px;
  @media (max-width: 820px)
    .modal-sidebar-desktop-open
      width: 100%;
  @media (max-width: 410px)
    .hide-break-1
      display none
    .show-break-1
      display initial

</style>




// WEBPACK FOOTER //
// View_Cumpleanios.vue?0e75987b